<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Strony</h2>
      <ol class="breadcrumb">
        <li><router-link to="/">Home</router-link></li>
        <li class="active"><strong>Strony</strong></li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Strony</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>

          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddPage" to="/pages/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <button @click="resetFilters" class="btn btn-primary btn-xs m-l-sm">
              <i class="fa fa-refresh"></i>
            </button>

            <div
              class="table-responsive table-search native-table-search m-t-sm"
            >
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th class="drag-column"></th>
                    <th class="index-column">#</th>
                    <th class="native-header-cell">
                      <button
                        type="button"
                        class="native-sort-button"
                        @click="toggleSort('url')"
                      >
                        <span>Adres strony</span>
                        <i
                          v-show="isSortedHeader('url')"
                          :class="sortIconClass('url')"
                          class="sort-icon fa"
                        ></i>
                      </button>
                      <input
                        class="table-search native-header-input"
                        type="text"
                        v-model="searchValue.url"
                        @keyup="search"
                        @click.stop="isSearch = true"
                      />
                    </th>
                    <th class="native-header-cell">
                      <button
                        type="button"
                        class="native-sort-button"
                        @click="toggleSort('title_seo')"
                      >
                        <span>Tytuł</span>
                        <i
                          v-show="isSortedHeader('title_seo')"
                          :class="sortIconClass('title_seo')"
                          class="sort-icon fa"
                        ></i>
                      </button>
                      <input
                        class="table-search native-header-input"
                        type="text"
                        v-model="searchValue.title_seo"
                        @keyup="search"
                        @click.stop="isSearch = true"
                      />
                    </th>
                    <th class="native-header-cell">
                      <button
                        type="button"
                        class="native-sort-button"
                        @click="toggleSort('type')"
                      >
                        <span>Typ</span>
                        <i
                          v-show="isSortedHeader('type')"
                          :class="sortIconClass('type')"
                          class="sort-icon fa"
                        ></i>
                      </button>
                      <input
                        class="table-search native-header-input"
                        type="text"
                        v-model="searchValue.type"
                        @keyup="search"
                        @click.stop="isSearch = true"
                      />
                    </th>
                    <th class="native-header-cell">
                      <button
                        type="button"
                        class="native-sort-button"
                        @click="toggleSort('menu')"
                      >
                        <span>Menu</span>
                        <i
                          v-show="isSortedHeader('menu')"
                          :class="sortIconClass('menu')"
                          class="sort-icon fa"
                        ></i>
                      </button>
                      <input
                        class="table-search native-header-input"
                        type="text"
                        v-model="searchValue.menu"
                        @keyup="search"
                        @click.stop="isSearch = true"
                      />
                    </th>
                    <th class="actions-column">Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="7" class="text-center">Ładowanie...</td>
                  </tr>
                  <tr v-else-if="!items.length">
                    <td colspan="7" class="text-center">Brak wyników</td>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, index) in items"
                    :key="item.pk"
                    class="reorder-row"
                    :class="{ 'drag-over-row': dragOverPagePk === item.pk }"
                    :draggable="canChangePage"
                    @dragstart="onPageDragStart(index, $event)"
                    @dragenter.prevent="onPageDragOver(index, $event)"
                    @dragover.prevent="onPageDragOver(index, $event)"
                    @drop.prevent="onPageDrop(index, $event)"
                    @dragend="onPageDragEnd"
                  >
                    <td class="drag-column" @click.stop>
                      <span
                        v-if="canChangePage"
                        class="drag-handle"
                        title="Przeciągnij, aby zmienić kolejność"
                      >
                        <i class="fa fa-bars"></i>
                      </span>
                    </td>
                    <td class="index-column">{{ rowNumber(index) }}</td>
                    <td>{{ item.url || item.url_pl || "-" }}</td>
                    <td>{{ item.title_seo || "-" }}</td>
                    <td>{{ item.type || "-" }}</td>
                    <td>{{ item.menu || "-" }}</td>
                    <td class="actions-column" @click.stop>
                      <button
                        v-if="canChangePage"
                        @click.stop="goToEdit(item.pk)"
                        class="btn btn-warning btn-xs"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        v-if="canDeletePage"
                        @click.stop="
                          showModal = item.pk;
                          deleteName = item.title_seo;
                        "
                        class="btn btn-danger btn-xs"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination" v-if="itemsAll">
              <span class="items-all"
                >Ilość rekordów: <b>{{ itemsAll }}</b></span
              >
              <span>
                Ilość na stronę:
                <select v-model="serverOptions.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverOptions.page" /> -
                {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
              </span>
              <button @click="selectPage(1)" class="btn btn-primary ml-25">
                Pierwsza
              </button>
              <button
                @click="serverOptions.page = serverOptions.page - 1"
                :disabled="serverOptions.page === 1"
                class="prev nl"
              ></button>
              <button
                @click="serverOptions.page = serverOptions.page + 1"
                :disabled="
                  serverOptions.page ===
                  Math.ceil(itemsAll / serverOptions.rowsPerPage)
                "
                class="next"
              ></button>
              <button
                @click="
                  selectPage(Math.ceil(itemsAll / serverOptions.rowsPerPage))
                "
                class="btn btn-primary"
              >
                Ostatnia
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deletePage(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import { hasPermission } from "../../permissions";
import { pagePermissionsConst } from "../../constants/pageConstants";

export default {
  name: "PagesList",
  components: { Modal },
  setup() {
    const store = useStore();
    const router = useRouter();
    const canAddPage = computed(() => hasPermission(pagePermissionsConst.add));
    // Reordering persists a new position on the page, so it is an edit.
    const canChangePage = computed(() =>
      hasPermission(pagePermissionsConst.update)
    );
    const canDeletePage = computed(() =>
      hasPermission(pagePermissionsConst.delete)
    );
    const deletePageData = computed(() => store.getters.getDeletePagesData);
    const pagesData = computed(() => store.getters.getPagesData);
    const updatePagesData = computed(() => store.getters.getUpdatePagesData);

    const items = ref([]);
    const itemsAll = ref(0);
    const loading = ref(true);
    const showModal = ref(false);
    const deleteName = ref("");
    const isSearch = ref(false);
    const isMainOpen = ref(true);
    const draggedPagePk = ref(null);
    const dragOverPagePk = ref(null);
    const isPageReorder = ref(false);
    const searchTimeout = ref(null);
    const searchValue = ref({
      url: "",
      title_seo: "",
      type: "",
      menu: "",
    });
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: "position",
      sortType: "asc",
    });

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const isSortedHeader = (value) => serverOptions.value.sortBy === value;

    const sortIconClass = (value) =>
      isSortedHeader(value) && serverOptions.value.sortType === "desc"
        ? "fa-sort-down"
        : "fa-sort-up";

    const toggleSort = (value) => {
      if (serverOptions.value.sortBy === value) {
        serverOptions.value.sortType =
          serverOptions.value.sortType === "asc" ? "desc" : "asc";
      } else {
        serverOptions.value.sortBy = value;
        serverOptions.value.sortType = "asc";
      }
    };

    const rowNumber = (index) => {
      const page = Number(serverOptions.value.page) || 1;
      const rows = Number(serverOptions.value.rowsPerPage) || 25;
      return (page - 1) * rows + index + 1;
    };

    const getPages = async () => {
      loading.value = true;
      const sort =
        serverOptions.value.sortType === "desc"
          ? `-${serverOptions.value.sortBy || "position"}`
          : serverOptions.value.sortBy || "position";
      await store.dispatch("getPages", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const goToEdit = (pk) => router.push({ name: "PagesEdit", params: { pk } });

    const deletePage = (pk) => {
      showModal.value = false;
      if (!canDeletePage.value) return;
      store.dispatch("deletePages", { pk });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {
        url: "",
        title_seo: "",
        type: "",
        menu: "",
      };
      serverOptions.value.page = 1;
      serverOptions.value.sortBy = "position";
      serverOptions.value.sortType = "asc";
      getPages();
    };

    const search = () => {
      isSearch.value = true;
      serverOptions.value.page = 1;
      if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
      }
      searchTimeout.value = setTimeout(() => {
        getPages();
        isSearch.value = false;
      }, 350);
    };

    const updateSort = () => {
      isSearch.value = false;
    };

    const onPageDragStart = (index, event) => {
      const item = items.value[index];
      if (!item || !event?.dataTransfer) return;
      draggedPagePk.value = item.pk;
      dragOverPagePk.value = item.pk;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", String(item.pk));
    };

    const onPageDragOver = (index, event) => {
      const item = items.value[index];
      if (!item) return;
      event.preventDefault();
      dragOverPagePk.value = item.pk;
    };

    const onPageDragEnd = () => {
      draggedPagePk.value = null;
      dragOverPagePk.value = null;
    };

    const onPageDrop = (index, event) => {
      event.preventDefault();
      const target = items.value[index];
      if (!canChangePage.value || !target || !draggedPagePk.value) {
        return onPageDragEnd();
      }
      const from = items.value.findIndex((i) => i.pk === draggedPagePk.value);
      const to = items.value.findIndex((i) => i.pk === target.pk);
      if (from < 0 || to < 0 || from === to) return onPageDragEnd();
      const [moved] = items.value.splice(from, 1);
      items.value.splice(to, 0, moved);
      isPageReorder.value = true;
      onPageDragEnd();
      // Pages reorder endpoint expects zero-based absolute position.
      const page = Number(serverOptions.value.page) || 1;
      const rows = Number(serverOptions.value.rowsPerPage) || 25;
      const zeroBasedPosition = (page - 1) * rows + to;
      store.dispatch("updatePages", {
        pk: moved.pk,
        position: zeroBasedPosition,
      });
    };

    onMounted(getPages);

    watch(
      () => pagesData.value,
      (v) => {
        itemsAll.value = v?.data?.count || 0;
        items.value = [...(v?.data?.results || [])];
        loading.value = false;
      }
    );

    watch(
      () => deletePageData.value,
      (v) => {
        if (v?.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Strona została usunięta",
          });
        }
        getPages();
      }
    );

    watch(
      () => updatePagesData.value,
      (v) => {
        if (!isPageReorder.value || !v?.status) return;
        isPageReorder.value = false;
        store.dispatch("showToaster", {
          type: v.status === 200 ? "success" : "error",
          content:
            v.status === 200
              ? "Kolejność stron została zaktualizowana"
              : "Nie udało się zmienić kolejności stron",
        });
        getPages();
      }
    );

    watch(
      () => serverOptions.value,
      () => {
        if (!isSearch.value) getPages();
      },
      { deep: true }
    );

    return {
      canAddPage,
      canChangePage,
      canDeletePage,
      items,
      itemsAll,
      loading,
      showModal,
      deleteName,
      searchValue,
      serverOptions,
      isMainOpen,
      chevronMainClass,
      dragOverPagePk,
      isSortedHeader,
      sortIconClass,
      toggleSort,
      rowNumber,
      goToEdit,
      deletePage,
      selectPage,
      resetFilters,
      search,
      updateSort,
      onPageDragStart,
      onPageDragOver,
      onPageDragEnd,
      onPageDrop,
      isSearch,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
.native-header-cell {
  min-width: 160px;
}
.native-header-input {
  margin-top: 6px;
  background-color: #f5f7fa;
  border: 1px solid #d8dde6;
  border-radius: 3px;
  padding: 4px 8px;
}
.native-header-input:focus {
  background-color: #fff;
  border-color: #1ab394;
  outline: none;
}
.native-sort-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 0;
}
.sort-icon {
  color: #676a6c;
}
.drag-column {
  width: 40px;
}
.index-column {
  width: 60px;
}
.actions-column {
  min-width: 110px;
}
.reorder-row {
  cursor: move;
}
.drag-handle {
  color: #999;
}
.drag-over-row td {
  border-top: 2px solid #1ab394 !important;
}
</style>
